<template>
  <main id="logout">
  </main>
</template>

<script>
export default {
  name: 'logout',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$store.commit('loader/open', 'ログアウト処理中です...')
    this.logout()
  },
  methods: {
    logout: function () {
      if ('signout' in this.$route.query) {
        this.$firebase.auth().signOut().then(() => {
          this.$store.commit('loader/close')
          this.$router.push('/login')
        })
      } else {
        let uri = [
          location.protocol + '//',
          location.hostname,
          location.hostname === 'localhost' ? (':' + location.port) : '',
          '/logout?signout'
        ].join('')
        location.href = this.$url.leg + 'sas/signout?redirect=' + encodeURIComponent(uri)
      }
      // let fd = new FormData()
      // this.axios.post('https://legacy.sasmango.com/sas/signout', fd).then(res => {
      // })
    }
  }
}
</script>
